import { useAuth } from "@/contexts/AuthContext";

const isTestAdminEnabled = process.env.REACT_APP_ENABLE_TEST_ADMIN === 'true';

const TestModeBanner = () => {
  const { user } = useAuth();
  
  if (!isTestAdminEnabled || user?.email !== 'paxadmin@local') {
    return null;
  }
  
  return (
    <div className="bg-orange-500 text-white text-center py-2 px-4 text-sm font-medium" data-testid="test-mode-banner">
      ⚠️ TRYB TESTOWY: Zalogowano jako ADMIN - tylko do celów deweloperskich
    </div>
  );
};

export default TestModeBanner;
